export default "<!-- <span [matTooltip]=\"toolTip\" matTooltipClass=\"tip\">\n  {{params.value}}\n</span> -->";